// A guest's private order code. Kept out of the page address where possible, so it
// doesn't end up in browser history, analytics or links shared with others.
const storageKey = (orderId) => `orderKey:${orderId}`;

export const rememberOrderKey = (orderId, key) => {
    try {
        sessionStorage.setItem(storageKey(orderId), key);
    } catch {
        // Storage blocked: the page still works for this view
    }
};

export const getOrderKey = (orderId) => {
    try {
        return sessionStorage.getItem(storageKey(orderId));
    } catch {
        return null;
    }
};
